import { Component, OnInit } from '@angular/core';
import { AuthService, JwtPayload } from '../auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'account-disabled',
  standalone: true,
  imports:[CommonModule],
  templateUrl: './account-disabled.component.html',
  styleUrls: ['./account-disabled.component.css']
})
export class AccountDisabledComponent implements OnInit {
  disabled: boolean = true;

  constructor(private authService: AuthService){}

  async checkStatus(){
    const response = await this.authService.checkAccountStatus();
   this.authService.updateAuthState(response);
  }

  async ngOnInit(): Promise<void> {
    this.checkStatus();
  }


}
